export default __webpack_public_path__ + "static/media/cross.193c6ea9.webp";